import {Model} from './model';

export class FinancingMethod implements Model {
  financingMethodId: number;
  name: string;
  description: string;

  static copy(oldObj: FinancingMethod): FinancingMethod {
    const newObj = new FinancingMethod();
    newObj.financingMethodId = oldObj.financingMethodId;
    newObj.name = oldObj.name;
    newObj.description = oldObj.description;
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.financingMethodId;
  }

  isNew(): boolean {
    return isNaN(this.financingMethodId);
  }

  clone(): FinancingMethod {
    return FinancingMethod.copy(this);
  }
}

export enum FinancingMethodId {
  DailyInterest = 'DI',
  FixedInterest = 'FI'
}
